import dayjs from 'dayjs';
import { NoteDetailsUI } from './ui';
import { BazanPriorityIcon } from '../ui/PriorityIcon';
import { BazanPriorityValues } from '../../enums/bazan';

export const isJSON = (string_) => {
  try {
    JSON.parse(string_);
    return true;
  } catch {
    return false;
  }
};

// LEGACY

export const BazanDetails = ({ SAPFields }) => {
  const details = isJSON(SAPFields) ? JSON.parse(SAPFields) : SAPFields;

  const getPriorityIcon = (priority) => {
    if (priority === 'מיידי') return <BazanPriorityIcon priority={BazanPriorityValues.Highest} />;
    if (priority === 'גבוה- תוך 3 ימים')
      return <BazanPriorityIcon priority={BazanPriorityValues.High} />;
    if (priority === 'בינוני - תוך 3 שבועות')
      return <BazanPriorityIcon priority={BazanPriorityValues.Medium} />;
    if (priority === 'נמוך - תוך 8 שבועות')
      return <BazanPriorityIcon priority={BazanPriorityValues.Low} />;

    return null as never;
  };

  return (
    <NoteDetailsUI>
      <NoteDetailsUI.Row label="Equipment" value={details?.equipment} />
      <NoteDetailsUI.Row label="Functional location" value={details?.functionalLocation} />
      <NoteDetailsUI.Row label="Fault type" value={details?.noteType} />
      <NoteDetailsUI.Row label="Equipment failure" value={details?.equipmentFailure} />
      <NoteDetailsUI.Row label="Fault Source" value={details?.faultSource} />
      <NoteDetailsUI.Row
        label="End date"
        value={dayjs(details?.endDate).format('MMMM D, hh:mm A')}
      />
      <NoteDetailsUI.Row
        label="Created at"
        value={dayjs(details?.createdAt).format('MMMM D, hh:mm A')}
      />
      <NoteDetailsUI.Row
        label="Priority"
        value={
          <>
            {getPriorityIcon(details?.priority)}
            <NoteDetailsUI.ValueText>{details?.priority || 'N/A'}</NoteDetailsUI.ValueText>
          </>
        }
      />
    </NoteDetailsUI>
  );
};
